module.exports = __webpack_public_path__ + "img/arrow-right.385a1ba4.svg";